var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.qualify)?[_c('router-view')]:[_c('Head'),_c('router-view'),_c('Bottom')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }